<template>
  <el-dialog title="填写今天的观测数据" :visible.sync="flag" width="50%">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="150px"
      :inline="true"
    >
      <el-form-item label="日期:" prop="date">
        <el-input v-model="form.date" style="width: 300px" disabled></el-input>
      </el-form-item>
      <el-form-item label="观测员:" prop="observer">
        <el-input v-model="form.observer" style="width: 300px"></el-input>
      </el-form-item>
      <!-- 上午 -->
      <el-divider content-position="center">上午</el-divider>
      <!-- 上午的观测时间 -->
      <div>
        <el-form-item label="观测时间:" prop="time1">
          <el-time-picker
            v-model="form.time1"
            :picker-options="{
              selectableRange: '06:00:00 - 11:30:00',
            }"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            placeholder="选择观测时间"
          >
          </el-time-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="chooseshebei(1)"
            >自动获取</el-button
          >
        </el-form-item>
      </div>

      <!-- [优化] 上午的数据: 使用 v-for 循环生成 -->
      <el-form-item
        v-for="field in observationFields"
        :key="'am-' + field.propKey"
        :label="field.label"
        :prop="field.propKey + '1'"
      >
        <el-input
          v-model="form[field.propKey + '1']"
          style="width: 130px"
          :placeholder="field.placeholder"
        ></el-input>
      </el-form-item>

      <!-- 下午 -->
      <el-divider content-position="center">下午</el-divider>
      <!-- 下午的观测时间 -->
      <div>
        <el-form-item label="观测时间:" prop="time2">
          <el-time-picker
            v-model="form.time2"
            :picker-options="{
              selectableRange: '13:00:00 - 20:00:00',
            }"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            placeholder="选择观测时间"
            @change="hanlderChange1"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chooseshebei(2)"
            >自动获取</el-button
          >
        </el-form-item>
      </div>

      <!-- [优化] 下午的数据: 使用 v-for 循环生成 -->
      <el-form-item
        v-for="field in observationFields"
        :key="'pm-' + field.propKey"
        :label="field.label"
        :prop="field.propKey + '2'"
      >
        <el-input
          v-model="form[field.propKey + '2']"
          style="width: 130px"
          :placeholder="field.placeholder"
        ></el-input>
      </el-form-item>

      <!-- 昨日最高最低温 -->
      <el-divider content-position="center">昨日温度</el-divider>
      <el-form-item label="昨日最低温°C:" prop="minTem">
        <el-input
          v-model="form.minTem"
          style="width: 130px"
          placeholder="示例:26.0"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="昨日最高温°C:"
        prop="maxTem"
        style="margin-left: 40px"
      >
        <el-input
          v-model="form.maxTem"
          style="width: 130px"
          placeholder="示例:26.0"
        ></el-input>
      </el-form-item>
      <div></div>
      <el-form-item label="最低温出现时间:" prop="minTemTime">
        <el-time-picker
          v-model="form.minTemTime"
          style="width: 130px"
          placeholder="示例:08:00"
          format="HH:mm"
          value-format="HH:mm"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item
        label="最高温出现时间:"
        prop="maxTemTime"
        style="margin-left: 40px"
      >
        <el-time-picker
          v-model="form.maxTemTime"
          style="width: 130px"
          placeholder="示例:08:00"
          format="HH:mm"
          value-format="HH:mm"
        >
        </el-time-picker>
      </el-form-item>

      <!-- 昨日最高最低湿度 -->
      <el-divider content-position="center"
        >昨日湿度（非必填，自动观测站可选填）</el-divider
      >
      <el-form-item label="昨日最低湿度%:" prop="minHumidity">
        <el-input
          v-model="form.minHumidity"
          style="width: 130px"
          placeholder="示例:60"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="昨日最高湿度%:"
        prop="maxHumidity"
        style="margin-left: 40px"
      >
        <el-input
          v-model="form.maxHumidity"
          style="width: 130px"
          placeholder="示例:80"
        ></el-input>
      </el-form-item>
      <div></div>
      <el-form-item label="最低湿度出现时间:" prop="minHumidityTime">
        <el-time-picker
          v-model="form.minHumidityTime"
          style="width: 130px"
          placeholder="示例:08:00"
          format="HH:mm"
          value-format="HH:mm"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item
        label="最高湿度出现时间:"
        prop="maxHumidityTime"
        style="margin-left: 40px"
      >
        <el-time-picker
          v-model="form.maxHumidityTime"
          style="width: 130px"
          placeholder="示例:08:00"
          format="HH:mm"
          value-format="HH:mm"
        >
        </el-time-picker>
      </el-form-item>
      <!-- 观测体会及最美瞬间 -->
      <el-divider content-position="center"></el-divider>
      <el-form-item label="观测体会:" prop="report">
        <el-input
          type="textarea"
          v-model="form.report"
          style="width: 700px"
          :maxlength="200"
          show-word-limit
          :rows="6"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="最美瞬间:" prop="applyUrl">
        <el-upload
          class="upload-demo"
          accept="image/png, image/jpeg"
          :action="action"
          multiple
          :limit="1"
          :before-upload="handleBefore"
          :on-success="handleSuccess"
          :file-list="fileList"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过5M
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="备注:">
        <el-input
          type="textarea"
          v-model="form.remark"
          style="width: 700px"
          :maxlength="100"
          show-word-limit
          :rows="4"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="flag = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
    <chooseShebeiVue ref="choose"></chooseShebeiVue>
  </el-dialog>
</template>

<script>
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat"; // ES 2015
dayjs.extend(customParseFormat);

import { BASE } from "@/services/base";
import { $activity } from "@/services";
import chooseShebeiVue from "./chooseShebei.vue";

// [新增] 导入 Vuex 辅助函数
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    chooseShebeiVue,
  },
  data() {
    return {
      flag: false,
      form: {},
      rules: {
        observer: [
          {
            required: true,
            message: "请填写观测员",
            trigger: "blur",
          },
        ],
      },
      action: BASE + "/server/common/upload",
      fileList: [],
      isSubmit: true,

      // [优化] 将重复的表单项抽离为配置数组
      observationFields: [
        { label: "温度°C:", propKey: "tem", placeholder: "示例:26.0" },
        { label: "湿度%:", propKey: "humidity", placeholder: "示例:80" },
        { label: "气压hPa:", propKey: "barometer", placeholder: "示例:1008.6" },
        { label: "风向°:", propKey: "windDir", placeholder: "示例:360" },
        { label: "风速m/s:", propKey: "windSpeed", placeholder: "示例:1.6" },
        { label: "降水mm:", propKey: "rain", placeholder: "示例:6.6" },
        {
          label: "光照w/m²:",
          propKey: "solarRadiation",
          placeholder: "示例:260.1",
        },
        { label: "紫外线:", propKey: "uv", placeholder: "示例:2" },
      ],
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    ...mapGetters("match", ["currentMatchVersion"]),
  },
  methods: {
    setFlag(row) {
      // [新增] 确保 Vuex store 中的届数列表已加载
      this.$store.dispatch("match/fetchMatchVersionList");

      this.form = row;
      this.flag = true;
      this.form.date = dayjs().format("YYYY-MM-DD");
      this.form.userId = this.userInfo.id;
      if (row.photos) {
        this.fileList = [{ name: "已上传文件", url: row.photos }];
      } else {
        this.fileList = [];
      }
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          $activity
            .reportData({
              ...this.form,
              matchVersion: this.currentMatchVersion,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("上传成功");
                this.$parent.getTableList();
                this.flag = false;
              } else {
                this.$message.error(res.msg);
              }
            });
        }
      });
    },
    hanlderChange1(e) {
      console.log(e);
    },
    handleBefore(file) {
      if (file.size / 1024 / 1024 > 5) {
        this.$message.error("上传图片不能大于5M");
        this.fileList = [];
        return false;
      }
      return true;
    },
    handleSuccess(response) {
      if (response.code === 200) {
        this.$set(this.form, "photos", response.data.url);
      }
    },
    chooseshebei(type) {
      this.$refs.choose.setFlag(type);
    },
    async autoData(type, device) {
      let params = {};
      params.device = device;
      let currentHour = new Date().getHours();
      if (currentHour >= 0 && currentHour < 12) {
        if (type === 1) {
          params.time = dayjs().format("YYYYMMDDHHmmss");
          this.form.time1 = dayjs().format("HH:mm:ss");
        } else if (type === 2) {
          this.$message.error("还没到下午呢!");
          return;
        }
      } else {
        if (type === 1) {
          params.time = dayjs().format("YYYYMMDD") + "090000";
          this.form.time1 = dayjs().format("09:00:00");
        } else if (type === 2) {
          params.time = dayjs().format("YYYYMMDDHHmmss");
          this.form.time2 = dayjs().format("HH:mm:ss");
        }
      }

      if (!this.isSubmit) return;
      this.isSubmit = false;

      let { code, data, msg } = await $activity.getAutoData(params);
      this.isSubmit = true;

      if (code !== 200) {
        this.$message.error(msg);
        return;
      }

      // --- [优化] 重构 autoData 的赋值逻辑 ---
      // 动态赋值上午/下午
      const suffixKey = type.toString(); // '1' 或 '2'
      this.$set(this.form, "tem" + suffixKey, data.tempf);
      this.$set(this.form, "humidity" + suffixKey, data.humidity);
      this.$set(this.form, "barometer" + suffixKey, data.baromabsin);
      this.$set(this.form, "windDir" + suffixKey, data.winddir);
      this.$set(this.form, "windSpeed" + suffixKey, data.windspeedmph);
      this.$set(this.form, "rain" + suffixKey, data.dailyrainin);
      this.$set(this.form, "solarRadiation" + suffixKey, data.solarradiation);
      this.$set(this.form, "uv" + suffixKey, data.uv);
      // 'uv' 字段在你的原 autoData 逻辑中没有被赋值, 保持不变

      // 统一赋值 "昨日" 数据
      this.$set(this.form, "maxTem", data.maxTem);
      this.$set(this.form, "minTem", data.minTem);
      let timeStr = "YYYYMMDDHHmmss";
      this.$set(
        this.form,
        "minTemTime",
        dayjs("" + data.minTemTime, timeStr).format("HH:mm:ss")
      );
      this.$set(
        this.form,
        "maxTemTime",
        dayjs("" + data.maxTemTime, timeStr).format("HH:mm:ss")
      );
      this.$set(this.form, "minHumidity", data.minHum);
      this.$set(this.form, "maxHumidity", data.maxHum);
      this.$set(
        this.form,
        "minHumidityTime",
        dayjs("" + data.minHumTime, timeStr).format("HH:mm:ss")
      );
      this.$set(
        this.form,
        "maxHumidityTime",
        dayjs("" + data.maxHumTime, timeStr).format("HH:mm:ss")
      );
      // --- 赋值逻辑结束 ---

      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.el-form-item__label {
  font-size: 18px;
}
.el-divider__text {
  font-size: 20px;
}
.el-input__inner {
  font-size: 18px;
}
</style>
